module.exports = __webpack_public_path__ + "img/20220225151150780lod.823c800c.png";